<template>
  <v-dialog
    v-model="dialog"
    :max-width="maxWidth"
  >
    <template #activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        :disabled="disabled"
        :style="{ display: visible ? 'flex' : 'none' }"
        :title="title"
        :aria-label="title"
      >
        <template>
          <v-icon>mdi-comment-edit-outline</v-icon>
        </template>
      </v-btn>
    </template>

    <v-card>
      <v-card-title>Comment</v-card-title>

      <v-card-text>
        <v-container>
          <v-row dense>
            <v-col>
              <v-textarea
                v-model="comment"
                hint="Comment on the selected conversion records"
                label="Comment"
                persistent-hint
                @input="changed = true"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-select
          v-model="status"
          hint="Approval status of the record(s)"
          label="Approval status"
          :items="statuses"
          persistent-hint
          @input="changed = true"
        />
        <v-spacer />
        <v-btn
          @click="dialog = false"
          aria-label="Cancel"
        >
          Cancel
        </v-btn>
        <v-btn
          @click="onOk"
          :disabled="items.length <= 1 && !changed"
          aria-label="Save"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import DialogBase from '../dialogs/DialogBase.vue'

export default {
  mixins: [DialogBase],

  props: {
    items: {
      type: Array,
      required: true,
    },
    protocol: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    comment: null,
    status: null,
    changed: false,
    statuses: [
      { text: '', value: null },
      { text: 'Correct', value: 'CORRECT' },
      { text: 'Incorrect', value: 'INCORRECT' },
      { text: 'Questionable', value: 'QUESTIONABLE' },
    ],
  }),

  watch: {
    dialog(val) {
      if (val) {
        this.changed = false
        if (this.items.length === 1) {
          this.comment = this.items[0].comment
          this.status = this.items[0].curationStatus
        }
      }
    },
  },

  methods: {
    onOk() {
      this.$emit('updated', {
        comment: this.comment,
        status: this.status,
      })
      this.dialog = false
    },
  },
}
</script>
